module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS3.52194f65.jpg";